<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showDisciplinaryInvestigationSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'850px'}">
    <ng-template pTemplate="header">
        <div class="flex flex-row justify-content-between" style="margin: 20px 30px 0px 5px; width: 100%;">

            <div class="flex flex-row">
                <div>
                    <img class="disciplinary-header-complaint-img" src="{{disciplinary.ComplaintImageUrl}}"/>
                </div>
                <div class="disciplinary-header-complaint-info-block">
                    <div class="disciplinary-header-complaint-fullname">{{disciplinary.ComplaintFullName}}</div>
                    <div class="disciplinary-header-complaint-member-since">Member since: <span class="disciplinary-header-complaint-created">{{disciplinary.ComplaintMemberSince}}</span></div>
                </div>
            </div>

            <div>
                <div class="disciplinary-header-did-text">Disciplinary ID:</div>
                <div class="disciplinary-header-did-value">{{disciplinary.DisciplinaryId}}</div>
            </div>

        </div>
    </ng-template>

    <add-hearing-or-reason-disciplinary *ngIf="displayModalAddHearingOrReason"
                                        [displayModalAddHearingOrReason]="displayModalAddHearingOrReason"
                                        [disciplinaryActionId]="disciplinary.DisciplinaryActionId"
                                        [hearingOrReasonTitle]="hearingOrReasonTitle"
                                        [hearingOrReasonDescription]="hearingOrReasonDescription"
                                        (changedDisplayModalAddHearingOrReasonEmit)="changedDisplayModalAddHearingOrReasonEmit($event)"></add-hearing-or-reason-disciplinary>

    <p-dialog [(visible)]="displayModalInvestigation" [modal]="true" [style]="{width: '600px'}"
              [draggable]="false" [resizable]="false" (onHide)="displayModalInvestigation = false">
        <div class="m-0 investigation-modal-body">
            <p class="investigation-modal-title">Start Investigation</p>
            <p class="investigation-modal-description">If you commence this Investigation, it will be assigned to you until it is completed.</p>
            <p class="investigation-modal-description">All investigations must be finalized within 5 business days</p>
        </div>
        <div class="flex justify-content-end mt-20 mb-5" *ngIf="!loading">
            <div>
                <button pButton pRipple type="button" label="Cancel" class="outlined-white-btn" (click)="displayModalInvestigation = false"></button>
            </div>
            <div class="ml-20">
                <button pButton pRipple type="button" label="Start" class="bluedark-btn" (click)="setInvestigativeUserAndSetStatusInvestigation()"></button>
            </div>
        </div>
        <div style="text-align: center;" *ngIf="loading" class="mb-5">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>
    </p-dialog>

    <p-dialog [(visible)]="displayModalNoShow" [modal]="true" [style]="{width: '600px'}"
              [draggable]="false" [resizable]="false" (onHide)="displayModalNoShow = false">
        <div class="m-0 investigation-modal-body">
            <p class="investigation-modal-title">Driver No Show</p>
            <p class="investigation-modal-description">A no show to a hearing automatically results in a 30 day suspension.
            Upon expiry of suspension, the driver must request a new hearing date, otherwise considered resigned from Xpress</p>
        </div>
        <div class="flex flex-row mt-20 p-4">
            <div class="modal-noshow-suspension-label mr-4">Automatic Suspension:</div>
            <div class="modal-noshow-suspension-value">
                30 Days
            </div>
        </div>
        <div class="flex justify-content-end mt-20 mb-5" *ngIf="!loading">
            <div>
                <button pButton pRipple type="button" label="Cancel" class="outlined-white-btn" (click)="displayModalNoShow = false"></button>
            </div>
            <div class="ml-20">
                <button pButton pRipple type="button" label="Start" class="bluedark-btn" (click)="suspensionUserThirtyDays()"></button>
            </div>
        </div>
        <div style="text-align: center;" *ngIf="loading" class="mb-5">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>
    </p-dialog>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <div class="bx-pager bx-default-pager">
            <div class="bx-pager-item" [class]="'active'">
                <a class="bx-pager-link " data-slide-index="0">Details</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class]="(activeMenuTab === menuTab.Investigation ||
                 activeMenuTab === menuTab.Hearing || activeMenuTab === menuTab.Disciplinary) ? 'active' : ''">
                <a class="bx-pager-link" data-slide-index="1">Investigation</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class]="(activeMenuTab === menuTab.Hearing || activeMenuTab === menuTab.Disciplinary) ? 'active' : ''">
                <a class="bx-pager-link" data-slide-index="2">Hearing</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class]="(activeMenuTab === menuTab.Disciplinary) ? 'active' : ''">
                <a class="bx-pager-link" data-slide-index="3">Disciplinary</a>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Details">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 241px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="disciplinary-border-block">
                    <div class="flex flex-row flex-space-between">
                        <div>
                            <span class="disciplinary-status-label">Disciplinary Status:</span>
                            <span class="disciplinary-status-value"
                                  [style.color]="disciplinary.StatusColor"
                                  [style.background-color]="disciplinary.StatusBackColor">{{disciplinary.DisciplinaryStatusText}}</span>
                        </div>
                        <div>
                            <span class="disciplinary-priority-value">{{disciplinary.PriorityTypeText}} Priority</span>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div>
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Disciplinary ID:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.DisciplinaryId}}</div>

                            <div class="disciplinary-item disciplinary-label">Reported Date & Time:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CreatedAt}}</div>

                            <div class="disciplinary-item disciplinary-label">Source:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.SourceCase}}</div>

                            <div class="disciplinary-item disciplinary-label">Channel:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.Channel}}</div>

                            <div class="disciplinary-item disciplinary-label">Prohibited Acts:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.ProhibitedAct}}</div>

                            <div class="disciplinary-item disciplinary-label">Offense Code:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.Code}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div>
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Customer name:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerName}}</div>

                            <div class="disciplinary-item disciplinary-label">Customer E-mail:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerEmail}}</div>

                            <div class="disciplinary-item disciplinary-label">Customer Phone:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerPhone}}</div>

                            <div class="disciplinary-item disciplinary-label">Date, Time of offense:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.OffenseDateTime}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="disciplinary-border-block">
                    <div class="disciplinary-note-label">Notes</div>
                    <div class="disciplinary-note-description">{{disciplinary.Note}}</div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="flex flex-row flex-space-between m-4">
                    <div>
                        <span class="disciplinary-representative-fullname-label">Xpress Representative:</span>
                        <span class="disciplinary-representative-fullname">{{disciplinary.RepresentativeFullName}}</span>
                    </div>
                </div>

            </p-scrollPanel>

            <div class="flex justify-content-end p-4">
                <button class="bluedark-btn" pButton label="Start Investigation"
                        (click)="cancelOrOpenModalInvestigation()"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Investigation">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 241px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="mt-20">
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Investigator:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationUserFullName}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Start:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationStartedAt}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Finish:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationFinishedAt}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="disciplinary-note-label">Investigation report:</div>
                    <br />
                    <textarea rows="5" cols="30" [(ngModel)]="disciplinary.InvestigationReport" placeholder="Include your findings" pInputTextarea [autoResize]="true"></textarea>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="disciplinary-note-label">Investigation Recommendation:</div>
                    <br />
                    <p-dropdown placeholder="Please select" [(ngModel)]="disciplinary.DisciplinaryActionId" [options]="disciplinaryActions"
                                optionLabel="name" optionValue="value"></p-dropdown>
                </div>

                <div class="disciplinary-hr"></div>
                <div class="m-4">
                    <div class="cp-upload-img-block__upload">
                        <div *ngIf="this.disciplinary.InvestigationFileReports">
                            <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.InvestigationFileReports">
                                <a href="{{file.FileUrl}}" target="_blank">{{file.FileName}}</a>
                            </p>
                        </div>
                        <div *ngIf="this.disciplinary.InvestigationAttachmentReports">
                            <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.InvestigationAttachmentReports">
                                {{file.FileName}}
                            </p>
                        </div>
                        <div class="btn-disciplinary-report-upload-file" (click)="handleInputReportClick('idInvestigationReportInput')">Upload file</div>
                    </div>
                    <input id="idInvestigationReportInput"
                           type="file"
                           multiple
                           style="display: none"
                           (change)="handleInvestigationReportChange($event)" required />
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end p-4">
                <button class="bluedark-btn" pButton label="Submit" 
                        [disabled]="(!disciplinary.InvestigationReport || !disciplinary.DisciplinaryActionId || 
                        (this.disciplinary.InvestigationFileReports.length === 0 && !this.disciplinary.InvestigationAttachmentReports))"
                        (click)="openDisplayModalAddHearingOrReasonSideBar()"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Hearing">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 241px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="mt-20" *ngIf="!showHearingReport">
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Hearing date:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.HearingDate}}</div>

                            <div class="disciplinary-item disciplinary-label">Start time:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.HearingTime}}</div>
                        </div>
                    </div>

                    <div class="flex justify-content-start p-4">
                        <button class="red-outline-btn mr-4" pButton label="No show" [disabled]="disableBtnNoShowAndStartHearing"
                                (click)="displayModalNoShow = true"></button>
                        <button class="bluedark-btn" pButton label="Start" [disabled]="disableBtnNoShowAndStartHearing"
                                (click)="showHearingReport = true"></button>
                    </div>
                </div>
                <div class="mt-20" *ngIf="showHearingReport">
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Investigator:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationUserFullName}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Start:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationStartedAt}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Finish:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationFinishedAt}}</div>
                        </div>
                    </div>
                    <div class="m-4">
                        <div class="disciplinary-note-label">Hearing Report:</div>
                        <br />
                        <textarea rows="5" cols="30" [(ngModel)]="disciplinary.HearingReport" placeholder="Please record hearing results, including summary of investigation and discussiion points for the driver" pInputTextarea [autoResize]="true"></textarea>
                    </div>
                    <div class="m-4">
                        <div class="disciplinary-note-label">Driver Explanation</div>
                        <br />
                        <textarea rows="5" cols="30" [(ngModel)]="disciplinary.UserExplanation" placeholder="Please record driver explanation" pInputTextarea [autoResize]="true"></textarea>
                    </div>
                    <div class="m-4">
                        <div class="cp-upload-img-block__upload">
                            <div *ngIf="this.disciplinary.HearingFileReports">
                                <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.HearingFileReports">
                                    <a href="{{file.FileUrl}}" target="_blank">{{file.FileName}}</a>
                                </p>
                            </div>
                            <div *ngIf="this.disciplinary.HearingAttachmentReports">
                                <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.HearingAttachmentReports">
                                    {{file.FileName}}
                                </p>
                            </div>
                            <div class="btn-disciplinary-report-upload-file" (click)="handleInputReportClick('idHearingReportInput')">Upload file</div>
                        </div>
                        <input id="idHearingReportInput"
                               type="file"
                               multiple
                               style="display: none"
                               (change)="handleHearingReportChange($event)" required />
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end p-4" *ngIf="showHearingReport">
                <button class="bluedark-btn" pButton label="Next"
                        [disabled]="(!disciplinary.HearingReport || !disciplinary.UserExplanation || 
                        (this.disciplinary.HearingFileReports.length === 0 && !this.disciplinary.HearingAttachmentReports))"
                        (click)="saveHearingAndSetStatusPending()"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Disciplinary">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 241px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row m-4">
                    <div class="disciplinary-label">
                        Investigation Recommendation:
                    </div>
                    <div>
                        <p-dropdown placeholder="Please select" [(ngModel)]="disciplinary.DisciplinaryActionId" [options]="disciplinaryActions"
                                    optionLabel="name" optionValue="value"></p-dropdown>
                    </div>
                </div>
                <div class="flex flex-row m-4">
                    <div class="disciplinary-label">
                        Period:
                    </div>
                    <div>
                        <p-dropdown placeholder="Please select" [(ngModel)]="disciplinary.DisciplinaryPeriodId" [options]="disciplinaryPeriodList"
                                    optionLabel="name" optionValue="value"
                                    [disabled]="disciplinary.DisciplinaryActionId === disciplinaryActionEnum.Closed || disciplinary.DisciplinaryActionId === disciplinaryActionEnum.Ban"></p-dropdown>
                    </div>
                </div>
                <div class="flex flex-row m-4">
                    <div class="disciplinary-label">
                        Start of Sanction:
                    </div>
                    <div>
                        <p-calendar [(ngModel)]="disciplinary.SanctionStartedAt" [showTime]="true" [showSeconds]="true" [showIcon]="true"
                                    [disabled]="disciplinary.DisciplinaryActionId === disciplinaryActionEnum.Closed"></p-calendar>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end p-4">
                <button class="bluedark-btn" pButton label="Save" (click)="saveDisciplinaryAction()"></button>
            </div>
        </div>
    </div>

</p-sidebar>
